import React, {useCallback, useEffect, useState} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useSelector } from "react-redux";
import Typography from "@material-ui/core/Typography";
import { Loading } from "@cabinet-packages/components";
import OrderAccordion from "../components/Accordions/OrderAccordion";
import {getOrdersHistory} from "@cabinet-packages/api/api";

const useStyles = makeStyles((theme) => ({
  scrollContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "@media (max-width: 900px)": {
      height: "calc(100% - 61px)",
    },
    "@media (min-width: 900px)": {
      overflowY: "scroll",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  headerLabel: {
    color: theme.palette.primary.dark,
    textAlign: "start",
  },
  extraLabel: {
    color: theme.palette.primary.main,
    textAlign: "start",
  },
  loading: {
    gridColumnStart: "1",
    gridColumnEnd: "3",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  columnLabelsContainer: {
    display: "grid",
    gridTemplateColumns: "0.5fr 0.5fr 1.5fr 1.5fr 1fr",
    height: "15px",
    padding: "0px 16px",
    "@media(max-width: 900px)": {
      display: "none",
    },
  },
  columnLabel: {
    fontSize: "12px",
    fontWeight: 500,
    color: theme.palette.grey.text,
    "@media(max-width: 900px)": {
      fontSize: "9px",
    },
  },
  unactiveOrdersContainer: {
    display: "flex",
    flexDirection: "column",
  },
  divider: {
    backgroundColor: "#eaeaea",
    height: "1px",
    border: 0,
    margin: "20px 0px",
  },
  blockDivider: {
    backgroundColor: "#eaeaea",
    height: "1px",
    border: 0,
    margin: "20px 0px 20px 0px",
  },
}));

const CabinetOrdersHistory = ({activePatient}) => {
  const classes = useStyles();
  const [activePatientsOrders, setActivePatientsOrders] = useState(null)
  const [loading, setLoading] = useState(false)
  const activePatientOrders =
    activePatientsOrders &&
    activePatientsOrders.filter((order) => order.paymentStatus === "REJECTED");
  const pastPatientsOrders =
    activePatientsOrders &&
    activePatientsOrders.filter((order) => order.paymentStatus === "NOT_PAYED");
  const { catalog, actions, complexResearch } = useSelector((state) => state.assaysCatalog);
  const [expanded, setExpanded] = useState(false);

  const handleGetOrdersOfPatient = useCallback(async () => {
    if (catalog && actions && complexResearch && !activePatientOrders && !loading) {
      setLoading(true)
      const allPositions = [...actions, ...catalog, ...complexResearch];

      try {
        const results = await getOrdersHistory(activePatient.id).catch(() => [])
        setActivePatientsOrders(results.length === 0
            ? []
            : results.map((item) => {
              return {
                ...item,
                services: item.services.map((assay) => {
                  const findAssay = allPositions.find(
                      (itemFromAll) =>
                          +itemFromAll.id === +assay.idPacket &&
                          +itemFromAll.idConf === assay.idConf
                  );

                  if (findAssay) return findAssay;

                  return assay;
                }),
              };
            }),)
      } catch (e) {
        console.error(e)
      }
      setLoading(false)
    }
  }, [catalog, actions, complexResearch, activePatientsOrders, loading])

  useEffect(() => {
    handleGetOrdersOfPatient()
  }, [handleGetOrdersOfPatient])

  return (
    <div className={classes.scrollContainer}>
      {activePatientsOrders && catalog ? (
        <>
          {activePatientOrders.length === 0 ? (
            <div className={classes.loading}>
              <Typography>Замовлені дослідження відсутні.</Typography>
            </div>
          ) : (
            <div>
              <div className={classes.columnLabelsContainer}>
                <Typography />
                <Typography className={classes.columnLabel}>ID</Typography>
                <Typography className={classes.columnLabel}>
                  Дата здачі
                </Typography>
                <Typography className={classes.columnLabel}>Адреса</Typography>
                <Typography className={classes.columnLabel}>Ціна</Typography>
              </div>
              {activePatientsOrders
                .sort((a, b) => b.id - a.id)
                .map((order, index) => (
                  <OrderAccordion
                    key={index}
                    order={order}
                    active={true}
                    expanded={expanded}
                    setExpanded={setExpanded}
                  />
                ))}
            </div>
          )}
          {pastPatientsOrders.length !== 0 && (
            <>
              <hr className={classes.blockDivider} />
              <div>
                <Typography className={classes.extraLabel}>
                  Минулі замовлення
                </Typography>
                <div style={{ marginTop: "15px" }}>
                  <div className={classes.columnLabelsContainer}>
                    <Typography />
                    <Typography className={classes.columnLabel}>ID</Typography>
                    <Typography className={classes.columnLabel}>
                      Дата здачі
                    </Typography>
                    <Typography className={classes.columnLabel}>
                      Адреса
                    </Typography>
                    <Typography className={classes.columnLabel}>
                      Ціна
                    </Typography>
                  </div>
                  <div className={classes.unactiveOrdersContainer}>
                    {pastPatientsOrders
                      .sort((a, b) => b.id - a.id)
                      .map((order, index) => (
                        <OrderAccordion
                          key={index}
                          order={order}
                          active={false}
                          expanded={expanded}
                          setExpanded={setExpanded}
                        />
                      ))}
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <div className={classes.loading}>
          <Typography style={{ fontWeight: 500 }}>
            Завантаження даних, будь ласка, зачекайте.
          </Typography>
          <Loading />
        </div>
      )}
    </div>
  );
};

export default CabinetOrdersHistory;
